<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'ven-fornecedor') {
            next({ name: 'ven-fornecedor-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'ven-fornecedor') {
            this.$router.push({ name: 'ven-fornecedor-list' });
        }
    },
};
</script>
